export default __webpack_public_path__ + "static/media/img1.e5125f57.jpg";